import { BlankState } from '@domain-group/suit-theme'

import BlankStateImageUrl from './assets/no-orders.svg'

const OrdersBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImageUrl}>
    <BlankState.Title>No Approved Orders</BlankState.Title>

    <BlankState.Paragraph>
      This campaign doesn&apos;t have any approved orders. You can approve orders by
      confirming them in the Pending Orders screen.
    </BlankState.Paragraph>
  </BlankState>
)

export default OrdersBlankState
